import { Permission } from '@Constants/Permission.g';
import { useHasPermission } from '@Contexts/appContext';
import { useFeatureFlags } from '@Contexts/featureFlags';
import { memo, type ComponentProps } from 'react';
import { ContainerCard } from '../../Containers';

// @ai-generated 2026-10-22T10:53:17+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export const OrderContainersSection = memo(function OrderContainersSection(
    props: ComponentProps<typeof ContainerCard>,
) {
    const hasPermission = useHasPermission();
    const { isFeatureEnabled } = useFeatureFlags();

    // Without the container types the card cannot tell individually managed containers from pooled ones.
    const showsCard =
        isFeatureEnabled('CONTAINER_SERVICE') &&
        hasPermission(Permission.AuftragsbearbeitungContainerActionsRead) &&
        hasPermission(Permission.StammdatenContainerTypeRead);

    return showsCard ? <ContainerCard {...props} /> : null;
});
